// extracted by mini-css-extract-plugin
module.exports = {"root":"AppLoader_root__1Fm8f"};